export default "__VITE_ASSET__Xz6oSttN__"